import {
  ComponentsPlatformService,
  ManifestComponentExtensionType,
} from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { DATA } from '@wix/component-protocol/schema';
import { getFontPropeties } from '../constants';
import { checkContextMatch } from '../common/actionValidators/helpers';
import { isAllowedStylePresent } from '../common/actionValidators/actionVisibilityRules';
import { hasDataType } from '../../../utils/helpers';
import { EditorPointer } from '@wix/editor-document-logic-api';

/**
 * Text action validator
 *
 * Rules:
 * - Exclude OOI extension type
 * - Exclude rich text components (handled by rich-text actions)
 * - Show if any element has text style properties
 *
 * @param componentsAPI - Components platform service
 * @param editorPointers - Selected editor pointers
 * @returns true if text action should be shown
 */
export const createTextValidator = () => {
  return (
    componentsAPI: ComponentsPlatformService,
    editorPointers: EditorPointer<CompRef>[],
  ): boolean => {
    const rootContexts = editorPointers.map((editorPointer) =>
      componentsAPI.buildManifestAPI({ editorPointers: [editorPointer] }),
    );
    const fontProperties = new Set(getFontPropeties());

    for (const rootContext of rootContexts) {
      const isRichText = hasDataType(
        rootContext.resolver.getDataDefinitions(),
        DATA.DATA_TYPE.richText,
      );

      if (isRichText) {
        return false;
      }

      const isOOIExtensionType =
        editorPointers.length === 1 &&
        rootContext.resolver.getExtensionType() ===
          ManifestComponentExtensionType.OOI;

      if (isOOIExtensionType) {
        return false;
      }

      if (
        checkContextMatch(rootContext, (context) =>
          isAllowedStylePresent(context, fontProperties),
        )
      ) {
        return true;
      }
    }

    return false;
  };
};
